import CreateVendorModal from "./CreateVendorModal";

export default CreateVendorModal;